export default "__VITE_ASSET__Dac7SQVZ__"